import { render, staticRenderFns } from "./EmailSendSuccessfully.vue?vue&type=template&id=67351d0f&scoped=true&"
import script from "./EmailSendSuccessfully.vue?vue&type=script&lang=js&"
export * from "./EmailSendSuccessfully.vue?vue&type=script&lang=js&"
import style0 from "./EmailSendSuccessfully.vue?vue&type=style&index=0&id=67351d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67351d0f",
  null
  
)

export default component.exports